import { Box, Tooltip } from "@chakra-ui/react";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { THEME_COLOR_SCHEME } from "../utils/theme";

interface HeaderItemProps {
  icon: any;
  url: string;
  label: string;
}

export const NavBarItem = ({ icon, url, label }: HeaderItemProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isCurrent = useMemo(
    () => location.pathname === url,
    [location.pathname, url]
  );

  return (
    <Tooltip label={label}>
      <Box
        display={"flex"}
        width={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
        cursor={"pointer"}
        fontSize={"x-large"}
        color={isCurrent ? THEME_COLOR_SCHEME : undefined}
        padding={2}
        borderTopColor={isCurrent ? THEME_COLOR_SCHEME : "gray.300"}
        borderTopStyle={"solid"}
        borderTopWidth={4}
        onClick={() => navigate(url)}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          borderRadius={4}
          padding={2}
          transition={"all 0.3s"}
          width={"100%"}
          _hover={{
            backgroundColor: isCurrent ? undefined : THEME_COLOR_SCHEME,
            color: isCurrent ? undefined : "gray.300",
          }}
        >
          {icon}
        </Box>
      </Box>
    </Tooltip>
  );
};
